import { Locales } from '@monoimin/sb-types';

export const articleIntroDict: Record<
  Locales,
  { timeToRead: string; timeToReadShort: string; archive: string }
> = {
  en: {
    timeToRead: 'Reading Time: {timeToRead} min',
    timeToReadShort: '{timeToRead} min',
    archive: 'Archive',
  },
  de: {
    timeToRead: 'Lesezeit: {timeToRead} min',
    timeToReadShort: '{timeToRead} min',
    archive: 'Archiv',
  },
  ru: {
    timeToRead: 'Время чтения: {timeToRead} мин',
    timeToReadShort: '{timeToRead} мин',
    archive: 'Архив',
  },
  tr: {
    timeToRead: 'Okuma Süresi: {timeToRead} dk',
    timeToReadShort: '{timeToRead} dk',
    archive: 'Arşiv',
  },
  es: {
    timeToRead: 'Tiempo de lectura: {timeToRead} min',
    timeToReadShort: '{timeToRead} min',
    archive: 'Archivo',
  },
};

export const cardsCollectionDict: Record<
  Locales,
  { title: string; description: string }
> = {
  en: {
    title: 'Articles and news',
    description:
      'We follow changes in the industry, analyse the market, and answer frequently asked questions.',
  },
  de: {
    title: 'Artikelen en nieuws',
    description:
      'Wij volgen veranderingen in de sector, analyseren de markt en beantwoorden veelgestelde vragen.',
  },
  ru: {
    title: 'Статьи и новости',
    description:
      'Мы следим за изменениями в отрасли, анализируем рынок и отвечаем на часто задаваемые вопросы.',
  },
  tr: {
    title: 'Makaleler ve haberler',
    description:
      'Sektördeki değişiklikleri takip ediyor, piyasayı analiz ediyor ve sıkça sorulan soruları yanıtlıyoruz.',
  },
  es: {
    title: 'Artículos y noticias',
    description:
      'Seguimos los cambios en la industria, analizamos el mercado y respondemos a preguntas frecuentes.',
  },
};

export * from './SubscribePopupForm';
